module.exports = __webpack_public_path__ + "img/20699382912746608ceb19e4815ac261.a3b64b32.png";